import React from 'react';
import styled from 'styled-components';
import { SecondaryButton } from '../../common/elements/SecondaryButton';
import { Label } from '../../common/elements/Label';
import SmsCode from '../../../images/smskod.svg';
import EmailCode from '../../../images/emailkod.svg';
import { TextInput } from '../../common/elements/TextInput';
import { TYPES } from './LoginDetails';

export class LoginDetailsVerifyField extends React.Component {
	onChange = e => {
		this.props.handleChange(e.value);
	};

	onSubmit = async () => {
		this.props.submitVerificationCode();
	};

	handleVerificationCodeChange = changedVerificationCode => {
		this.props.handleVerificationCodeChange(changedVerificationCode.value);
	};

	formatVerificationDataValue = () => {
		let { verificationData } = this.props;

		let value = verificationData.value;
		if (verificationData.type === TYPES.PHONENUMBER) value = '+' + value;

		return value;
	};

	render() {
		const { verificationCode, type } = this.props;
		const formattedVerificationDataValue = this.formatVerificationDataValue();

		return (
			<>
				<h3>Bekräfta ändring</h3>

				<p>En kod har skickats till: {formattedVerificationDataValue}</p>
				<VerificationIcon
					src={type === TYPES.PHONENUMBER ? SmsCode : EmailCode}
					alt=""
				/>

				<div className="form-group">
					<Label htmlFor="code">Ange kod</Label>
					<TextInput
						type="text"
						value={verificationCode}
						handleChange={this.handleVerificationCodeChange}
						className="form-control"
						id="code"
						maxLength="6"
					/>
				</div>

				<FullWidthSecondaryButton onClick={this.onSubmit} disabled={false}>
					Nästa
				</FullWidthSecondaryButton>
			</>
		);
	}
}

const VerificationIcon = styled.img`
	margin: 1em auto;
	display: block;
	height: 60px;
`;

const FullWidthSecondaryButton = styled(SecondaryButton)`
	width: 100%;
`;
